import { render, staticRenderFns } from "./Teams.vue?vue&type=template&id=9d0fb108&scoped=true"
import script from "./Teams.vue?vue&type=script&lang=js"
export * from "./Teams.vue?vue&type=script&lang=js"
import style0 from "./Teams.vue?vue&type=style&index=0&id=9d0fb108&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d0fb108",
  null
  
)

export default component.exports